export class LedgerDetailUIState {
    constructor(filterState) {
        this.filterUiState = filterState;
    }
}
